import {FormControl} from '@angular/forms';

export interface IAvailabilityUpdateForm {
  jobStatus: FormControl<string>;
  lookingForProject: FormControl<boolean>;
  immediate: FormControl<boolean>;
  specificDate: FormControl<Date | null>;
  noticePeriod: FormControl<string>;
}

export interface IAvailabilityUpdateFormData {
  jobStatus: string;
  lookingForProject: boolean;
  immediate: boolean;
  specificDate: Date | null;
  noticePeriod: string;
}

export enum NoticePeriods {
  NONE = 'None',
  ONE_WEEK = 'One week',
  TWO_WEEKS = 'Two weeks',
  ONE_MONTH = 'One month',
  TWO_MONTHS = 'Two months',
}

export enum JobStatuses {
  ON_CONTRACT = 'ON_CONTRACT',
  NOT_ON_CONTRACT = 'NOT_ON_CONTRACT'
}
